export { default as SnykCard } from './SnykCard';

export const SNYK_ANNOTATION_ORG = 'snyk.io/org-id';
export const SNYK_ANNOTATION_TARGETNAME = 'snyk.io/target-name';
export const SNYK_ANNOTATION_TARGETID = 'snyk.io/target-id';
export const SNYK_ANNOTATION_PROJECT_NAMES = 'snyk.io/project-names';
